export default __webpack_public_path__ + "static/media/friendliness.7d2e5ffd.svg";